import styled from 'styled-components'

export const CustomHeaderContainer = styled.header<{ $openMenu: boolean }>`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 500;
  background-color: ${({ theme }) => theme?.webMktNewPalette?.background.light.default};

  .CustomHeader__Wrapper {
    padding: 0px 40px;
    display: flex;
    justify-content: space-between;
    max-width: 1584px;
  }
  .CustomHeader__Button {
    margin-left: 32px;
    white-space: nowrap;
  }
  .CustomHeader__Logo {
    width: 100%;
    min-height: 44px;
    max-width: 300px;
  }
  .CustomHeader__Left {
    display: flex;
    align-items: center;
    ul {
      ${({ theme }) => theme.breakpoints.down('sm')} {
        display: none;
      }
    }
    .countryText {
      padding: 0px 15px;
      border-left: 1px solid ${({ theme }) => theme?.webMktNewPalette?.deepBlue[55]};
      border-right: 1px solid ${({ theme }) => theme?.webMktNewPalette?.deepBlue[55]};
      margin-right: 32px;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        display: none;
      }
      a {
        font-size: 32px;
        font-family: Poppins;
        color: ${({ theme }) => theme?.webMktNewPalette?.deepBlue[55]};
        font-weight: 600;
        line-height: 31px;
        ${({ theme }) => theme.breakpoints.down('md')} {
          font-size: 24px;
          line-height: 24px;
        }
      }
    }
  }
  .CustomHeader__Right {
    display: flex;
    margin: auto 0;
    align-items: center;
    .logoHref {
      display: none;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        display: block;
      }
    }
    ul {
      display: none;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        display: block;
        border-top: 1px solid rgb(222, 230, 234);
        margin: 16px 0 0;
      }
    }
    .homeLink {
      margin-right: 10px;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        display: none;
        padding: 16px 32px;
        border-bottom: 1px solid rgb(222, 230, 234);
      }
      a {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        gap: 8px;
        color: ${({ theme }) => theme.webMktNewPalette.black};
        font-size: 14px;
        font-weight: 700;
        color: rgb(26, 26, 26);
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    .CustomHeader__Wrapper {
      padding: 8px 0;
      max-width: none;
    }

    .CustomHeader__Logo {
      width: 300px;
      margin-left: 16px;
    }

    .CustomHeader__Right {
      display: none;
      width: 100%;
    }
  }

  ${({ $openMenu }) => {
    return $openMenu
      ? `
      .CustomHeader__Left {
        display: none;
      }
      
      .CustomHeader__Right {
        display: block;
        margin-top: 0px;
      }

      .CustomHeader__Button {
        margin: 21px auto 40px 32px;
        width: calc(100% - 64px);
        justify-content:center;
      }
    `
      : ``
  }}
`

export const NavLinks = styled.ul<{ $openMenu: boolean }>`
  display: flex;
  flex-direction: ${({ $openMenu }) => ($openMenu ? 'column' : 'row')};

  .CustomHeader__MenuGroup {
    margin: auto 0;

    p:hover {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    }
  }

  .CustomHeader__NavLink {
    margin: auto 0;
    ${({ theme }) => theme.breakpoints.down('sm')} {
      border-bottom: 1px solid rgb(222, 230, 234);
    }

    a {
      display: block;
      padding: 32px 12px;
      p {
        font-size: 20px;
        font-weight: 600;
        letter-spacing: -1px;
        line-height: 24px;
        ${({ theme }) => theme.breakpoints.down('sm')} {
          font-size: 18px;
          line-height: 20px;
          margin: 0;
        }
      }
    }

    &:hover {
      p {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
      }
    }
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    .CustomHeader__Mobile_Button {
      display: none;
    }

    .CustomHeader__MenuGroup {
      &:hover .CustomHeader__Sublinks {
        display: block;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    .CustomHeader__NavLink a {
      padding: 16px 32px;
    }

    .NavLink_List,
    .CustomHeader__Sublinks {
      display: none;
    }

    .CustomHeader__Dropdown {
      position: static;

      .CustomHeader__Sublinks {
        position: static;
        display: block;
        margin: 0 32px;
        background-color: ${({ theme }) => theme?.webMktNewPalette?.deepBlue[10]};
        box-shadow: none;

        p {
          font-weight: ${({ theme }) => theme?.webMktTypography?.fontWeights?.regular};
          font-size: ${({ theme }) => theme?.webMktTypography?.fontSizes[2]};
        }
      }
    }

    .CustomHeader__Mobile_Button {
      padding: 16px 32px;
      width: 100%;
      text-align: left;
      text-transform: none;
    }

    .Menu-item.is-active {
      background-color: unset;

      p {
        color: ${({ theme }) => theme.webMktNewPalette.black};
      }

      &::before {
        border-left: 2px solid ${({ theme }) => theme.webMktNewPalette.black};
        border-bottom: 2px solid ${({ theme }) => theme.webMktNewPalette.black};
      }
    }

    .Menu-item::before {
      right: 36px;
    }
  }
`

export const SubLinks = styled.ul`
  background-color: ${({ theme }) => theme?.webMktNewPalette?.background.light.default};
  position: absolute;
  top: 75px;
  box-shadow: rgb(0 0 0 / 20%) 0px 16px 16px -8px;

  .CustomHeader__Sublink {
    a {
      padding: 8px 60px 8px 16px;
      display: block;
    }

    &:hover {
      background-color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};

      p {
        color: ${({ theme }) => theme?.webMktNewPalette?.white};
      }
    }
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    display: none;
  }
`

export const ResponsiveIcon = styled.div<{ $openMenu: boolean }>`
  display: none;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;

  .CustomHeader__Hamburger {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: space-evenly;
    flex-flow: column nowrap;

    div {
      width: 20px;
      height: 2px;
      background-color: ${({ theme }) => theme?.webMktNewPalette?.background?.dark.default};
    }
  }

  ${({ $openMenu, theme }) => {
    return $openMenu
      ? `
      width: 80px;

      &:hover {
        p {
          color: ${theme.webMktNewPalette.action.light.primary};
        }

        .CustomHeader__Hamburger div {
          background-color: ${theme?.webMktNewPalette?.background?.dark.default};
        }
      }

      .CustomHeader__Close {
        position: absolute;
        right: 35px;
        color: ${theme.webMktNewPalette.black};
      }

      .CustomHeader__Hamburger {
        position: relative;
        left: 55px;

        div {
          width: 24px;
        }

        div:nth-child(1) {
          transform: translate(-1px, 7px) rotate(-315deg);
          top: 20px;
        }
    
        div:nth-child(2) {
          opacity: 0;
        }
    
        div:nth-child(3) {
          transform: translate(-1px, -6px) rotate(-225deg);
        }
      }
    `
      : `
      .CustomHeader__Close {
        display: none;
      }
    `
  }}

  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: block;
  }
`
